import { createFeatureSelector } from '@ngrx/store';

export const reorderState = createFeatureSelector<OLO.State, OLO.State.Reorder[]>('reorder');
